import React from 'react'
import { Plant } from '../../../types/plant'

interface PlantCardProps {
  plant: Plant
  onClick: (id: number) => void
  isValidUrl: (url: string | null | undefined) => boolean
}

const PlantCard: React.FC<PlantCardProps> = ({ plant, onClick, isValidUrl }) => {
  return (
    <div className='plant-card' onClick={() => onClick(plant.id)}>
      <div className='plant-card__img'>
        {!plant.imagePresignedUrl && !plant.image
          ? (
            <div className='img-placeholder'>
              <div className='spinner-border text-light' role='status'>
                <span className='sr-only'>Ładowanie...</span>
              </div>
            </div>
            )
          : (
            <div className='img-container'>
              <img
                src={(isValidUrl(plant.image) ? (plant.image || plant.imagePresignedUrl) : plant.imagePresignedUrl)}
                alt={plant.name}
                className='img-fluid'
                loading='lazy'
              />
            </div>
            )}
      </div>
      <div className='plant-card__body'>
        <h5 className='plant-card__title'>{plant.name}</h5>
        <p className='plant-card__latin-name'>{plant.latinName}</p>
        <p className='plant-card__desc'>{plant.description.substring(0, 70)}...</p>
      </div>
    </div>
  )
}

export default PlantCard
